import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import styled from 'styled-components';

import { State } from 'src/state/ducks';
import * as actions from 'src/state/ducks/admin/actions';

import { DefaultPageProps, HistoryProps } from 'src/constants/Interface';

import LoginLayout from 'src/components/layouts/LoginLayout';
import Bar from 'src/components/atoms/shapes/Bar';
// import LoginForm from "src/components/organisms/form/LoginForm";
import StyleConfig from 'src/constants/StyleConfig';
import { LinkButton } from 'src/components/atoms/button/Button';

type Props = DefaultPageProps &
  HistoryProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class RegisterPage extends Component<Props> {
  render() {
    return (
      <LoginLayout>
        <Block>
          <h1 className="logo">
            <img src="/images/pages/login/logo.png" alt={'sacri'} />
          </h1>
          <p>只今新規登録受付を停止しております</p>
          <div className="new-user">
            <Bar />
            <p className="heading">会員登録済みの方</p>
            <LinkButton
              isDisabled={false}
              buttonColor={'secondary'}
              url={'/login'}
              text={'ログインはこちら'}
            />
          </div>
        </Block>
      </LoginLayout>
    );
  }
}

const Block = styled.div`
  .logo {
    width: 147px;
    margin: 0 auto ${StyleConfig.HELPER.M32};
    text-align: center;
  }

  .forget {
    display: block;
    margin: 24px auto;
    text-align: center;
    font-size: 12px;
    line-height: 1;
    color: #000;
  }
  .new-user {
    margin-top: ${StyleConfig.HELPER.M40};

    .heading {
      margin-top: ${StyleConfig.HELPER.M24};
      font-weight: bold;
      font-size: 14px;
      margin-bottom: ${StyleConfig.HELPER.M8};
    }
  }
`;

const mapStateToProps = (state: State) => {
  return {
    error: state.admin.apiError,
    isSignIn: state.admin.isSignIn,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    login: (payload: { email: string; password: string }) => dispatch(actions.login(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterPage);
